<template>
  <span class="typing">
    <span class="typing__anim-dot" />
    <span class="typing__anim-dot" />
    <span class="typing__anim-dot" />
  </span>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
@use 'sass:math';

.typing {
  display: inline-flex;

  &__anim-dot {
    width: $bb-spacing-2;
    height: $bb-spacing-2;
    margin: 0 math.div($bb-spacing-1, 2);

    border-radius: $bb-spacing-2;
    background-color: $bb-neutral-3;

    animation: wave 1.3s linear infinite;

    &:nth-child(2) {
      animation-delay: -1.1s;
    }

    &:nth-child(3) {
      animation-delay: -0.9s;
    }
  }
}
</style>
